/*
Documentation

this page holds all the routes for the developers layout

*/

import Settings from '../pages/_core/Settings';

import ProjectsAll from '../pages/projects/All';
import ProjectsView from '../pages/projects/View';
import ProjectsLogsAll from '../pages/projects/LogsAll';
import ProjectBillables from '../pages/projects/Billables';


import BackendResponses from '../pages/development/backend/Responses';
import BackendSecurity from '../pages/development/backend/Security';
import BackendTesting from '../pages/development/backend/Testing';

import CodeComments from '../pages/development/code/Comments';
import CodeFormatting from '../pages/development/code/Formatting';
import CodeGit from '../pages/development/code/Git';

import FrontendErrors from '../pages/development/frontend/Errors';
import FrontendScss from '../pages/development/frontend/Scss';
import FrontendSecurity from '../pages/development/frontend/Security';

import ResourcesAll from '../pages/development/resources/All';

export default [

    {
        divider: 'My Projects',
        name: 'View All',
        icon: 'fas fa-home text-success',
        path: "/",
        component: ProjectsAll,
        show_in_sidebar: true
    },
    {
        name: 'Project Logs',
        icon: 'fas fa-file-code text-success',
        path: "/logs/all",
        component: ProjectsLogsAll,
        show_in_sidebar: true
    },
   

    {
        name: 'Billables',
        icon: 'fas fa-money-check-alt text-success',
        path: "/billables",
        component: ProjectBillables,
        show_in_sidebar: true
    },
    {
        path: "/projects/:_id",
        component: ProjectsView,
        show_in_sidebar: false
    },

    {
        divider: 'Development',
        collapse: true,
        name: "Code",
        icon: "fas fa-code-branch text-info",
        state: "DevelopmentCode",
        views: [
            {
                path: "/development/code/git",
                name: "Git",
                component: CodeGit,
                show_in_sidebar: true,
            },
            {
                path: "/development/code/comments",
                name: "Comments",
                component: CodeComments,
                show_in_sidebar: true,
            },
            {
                path: "/development/code/formatting",
                name: "Formatting",
                component: CodeFormatting,
                show_in_sidebar: true,
            },
        ]
    },
    {
        collapse: true,
        name: "Frontend",
        icon: "fas fa-laptop-code text-info",
        state: "DevelopmentFrontend",
        views: [
            {
                path: "/development/frontend/errors",
                name: "Errors",
                component: FrontendErrors,
                show_in_sidebar: true,
            },
            {
                path: "/development/frontend/scss",
                name: "SCSS",
                component: FrontendScss,
                show_in_sidebar: true,
            },
         
            {
                path: "/development/frontend/security",
                name: "Security",
                component: FrontendSecurity,
                show_in_sidebar: true,
            },
        ]
    },
   
    {
        collapse: true,
        name: "Backend",
        icon: "fas fa-server text-info",
        state: "DevelopmentBackend",
        views: [
            {
                path: "/development/backend/security",
                name: "Security",
                component: BackendSecurity,
                show_in_sidebar: true,
            },
            {
                path: "/development/backend/testing",
                name: "Testing",
                component: BackendTesting,
                show_in_sidebar: true,
            },
         
            {
                path: "/development/backend/responses",
                name: "Responses",
                component: BackendResponses,
                show_in_sidebar: true,
            },
        ]
    },

    {
        name: 'Resources',
        icon: 'fas fa-thumbs-up text-info',
        path: "/development/resources",
        component: ResourcesAll,
        show_in_sidebar: true
    },
   

    {
        divider: 'Account',
        name: 'Settings',
        icon: 'fas fa-cogs text-primary',
        path: "/settings",
        component: Settings,
        show_in_sidebar: true
    },

]